export default {
  saveSubscriptionPlans: (context, payload) => {
    context.commit('setSubscriptionPlans', payload)
  },
}
